import React from 'react';
import DefaultView from '@plone/volto/components/theme/View/DefaultView';

const DocumentView = (props) => {
  const { content } = props;
  if (!content?.suppress_title) return <DefaultView {...props} />;

  const filteredBlocks = Object.fromEntries(
    Object.entries(content.blocks || {}).filter(
      ([_, b]) => b['@type'] !== 'title',
    ),
  );
  const filteredItems = (content.blocks_layout?.items || []).filter(
    (id) => content.blocks?.[id]?.['@type'] !== 'title',
  );
  const filteredContent = {
    ...content,
    blocks: filteredBlocks,
    blocks_layout: { ...content.blocks_layout, items: filteredItems },
  };
  return <DefaultView {...props} content={filteredContent} />;
};

export default DocumentView;
